import {useEffect, useState} from 'react'
import DB from '../DAL/DB'
import {FULL_TEXT_SEARCH_URL} from '../config'
import {auth} from '../Auth'

function makeQuery(type, options) {
  if (!options) options = {}

  if (!options.size) options.size = 10000

  return {type, ...options}
}

const meta = new DB.Meta()

export default function useElasticSubscribe(collection, options = {}) {
  const [resources, setResources] = useState([])
  const [lastUpdate, setLastUpdate] = useState(null)

  const {transform} = options
  delete options.transform

  async function refresh() {
    const query = makeQuery(collection, options)
    const url = `${FULL_TEXT_SEARCH_URL}/full_search`
    const token = await auth.getToken(); 
    const headers = { 
      'Content-Type': `application/json` 
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    let res = await (
      await fetch(url, {
        method: `POST`,
        mode: `cors`,
        headers,
        body: JSON.stringify(query),
      })
    ).json()

    if (transform) res = transform(res)
    setResources(res)
  }

  useEffect(function () {
    return meta.subscribe('elasticUpdates', null, async function ({ok, data}) {
      if (ok) {
        const update = data[collection]

        if (lastUpdate === update) return

        setLastUpdate(update)
        await refresh()
      }
    })
  }, [])

  return resources
}
